import { useEffect, useState } from 'react';
import { useYmaps } from './useYmaps';
import { useSelector } from 'react-redux';
import { selectHouseCoordinates } from 'shared/selectors/houseInfo';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { TPanorama } from '../types';
import { getYandexData } from '../utils';
import { usePanoramaEnabled } from './usePanoramaEnabled';

export const usePanorama = () => {
  const { logger } = useApplicationContext();

  const ymaps = useYmaps();

  const panoramaEnabled = usePanoramaEnabled();

  const coordinates = useSelector(selectHouseCoordinates);

  const [panoramas, setPanoramas] = useState<TPanorama[]>([]);

  useEffect(() => {
    if (!panoramaEnabled || !coordinates || !ymaps?.panorama.isSupported()) {
      return;
    }

    const { lat, lng } = coordinates;

    getYandexData({
      request: ymaps.panorama.locate([lng, lat]),
      onSuccess: setPanoramas,
      onError: error => logger.warning(error, { degradation: 'Ошибка при поиске панорамы дома' }),
    });
  }, [coordinates, logger, panoramaEnabled, ymaps]);

  return panoramas[0];
};
